export default "__VITE_ASSET__5a3c1fda__"